import * as React from 'react'
import { useTranslation } from 'hooks'
import { withTranslations } from 'helpers'
import * as S from './Paginator.styles'

const Paginator: React.FC<Props> = ({
  page: currentPage,
  totalPages,
  window: windowSize,
  onPageChange: customPageChange
}) => {
  const { t } = useTranslation()
  const onPageChange =
    customPageChange ||
    ((page: number) => {
      const searchParams = new URLSearchParams(window.location.search)

      searchParams.set('page', `${page}`)
      window.location.search = searchParams.toString()
    })

  let previousPage: React.ReactNode = ''
  let leftEllipsis: React.ReactNode = ''
  let link: React.ReactNode = ''
  let nextPage: React.ReactNode = ''
  let rightEllipsis: React.ReactNode = ''

  if (!(currentPage - 1 <= 0)) {
    previousPage = (
      <S.PrevNextButton
        onClick={() => {
          onPageChange(currentPage - 1)
        }}
      >
        {t('shared.previous')}
      </S.PrevNextButton>
    )
  }

  const pageWindow: number[] = []
  let i = currentPage - windowSize

  while (i < currentPage) {
    if (i >= 1) {
      pageWindow.push(i)
    }

    i++
  }

  pageWindow.push(currentPage)

  i = currentPage + 1
  while (i <= currentPage + windowSize && i <= totalPages) {
    pageWindow.push(i)
    i++
  }

  if (currentPage > windowSize + 1) {
    leftEllipsis = <span>&hellip;</span>
  }

  const currentWindow: React.ReactNode[] = []

  pageWindow.forEach((page) => {
    if (page == currentPage) {
      link = (
        <S.PageButton
          key={`page-${page}`}
          active
          onClick={() => onPageChange(page)}
          aria-current="page"
        >
          {page}
        </S.PageButton>
      )
    } else {
      link = (
        <S.PageButton key={`page-${page}`} onClick={() => onPageChange(page)}>
          {page}
        </S.PageButton>
      )
    }

    currentWindow.push(link)
  })

  if (currentPage + 1 <= totalPages) {
    nextPage = (
      <S.PrevNextButton
        onClick={() => {
          onPageChange(currentPage + 1)
        }}
      >
        {t('shared.next')}
      </S.PrevNextButton>
    )
  }

  if (currentPage + windowSize < totalPages) {
    rightEllipsis = <span>&hellip;</span>
  }

  return (
    <S.PaginatorContainer>
      {previousPage} {leftEllipsis} {currentWindow} {rightEllipsis} {nextPage}
    </S.PaginatorContainer>
  )
}

export default withTranslations(Paginator)

interface Props {
  totalPages: number
  page: number
  window: number
  onPageChange?: (page: number) => void
}
